module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAABtJREFUCB1j/M/AYM/AwOAAxLQGB5hobQOy+QCWbgJCJpGLywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/hypo.png
// module id = 703
// module chunks = 1